import {
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
  createFetchType,
} from '../actionHelpers';

// create metal stream bank account
const CREATE_METAL_STREAM_BANK_ACCOUNT_SCOPE =
  'CREATE_METAL_STREAM_BANK_ACCOUNT';
export const CREATE_METAL_STREAM_BANK_ACCOUNT = createSubmitType(
  CREATE_METAL_STREAM_BANK_ACCOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_ACCOUNT_SUCCESS = createSuccessType(
  CREATE_METAL_STREAM_BANK_ACCOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_ACCOUNT_ERROR = createErrorType(
  CREATE_METAL_STREAM_BANK_ACCOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_ACCOUNT_LOADING = createLoadingType(
  CREATE_METAL_STREAM_BANK_ACCOUNT_SCOPE,
);

// create metal stream funding
const CREATE_METAL_STREAM_AMOUNT_SCOPE = 'CREATE_METAL_STREAM_AMOUNT';
export const CREATE_METAL_STREAM_AMOUNT = createSubmitType(
  CREATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_AMOUNT_SUCCESS = createSuccessType(
  CREATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_AMOUNT_ERROR = createErrorType(
  CREATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const CREATE_METAL_STREAM_AMOUNT_LOADING = createLoadingType(
  CREATE_METAL_STREAM_AMOUNT_SCOPE,
);

// update metal stream funding
const UPDATE_METAL_STREAM_AMOUNT_SCOPE = 'UPDATE_METAL_STREAM_AMOUNT';
export const UPDATE_METAL_STREAM_AMOUNT = createSubmitType(
  UPDATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const UPDATE_METAL_STREAM_AMOUNT_SUCCESS = createSuccessType(
  UPDATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const UPDATE_METAL_STREAM_AMOUNT_ERROR = createErrorType(
  UPDATE_METAL_STREAM_AMOUNT_SCOPE,
);
export const UPDATE_METAL_STREAM_AMOUNT_LOADING = createLoadingType(
  UPDATE_METAL_STREAM_AMOUNT_SCOPE,
);

// create metal stream allocation
const CREATE_METAL_STREAM_ALLOCATION_SCOPE = 'CREATE_METAL_STREAM_ALLOCATION';
export const CREATE_METAL_STREAM_ALLOCATION = createSubmitType(
  CREATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const CREATE_METAL_STREAM_ALLOCATION_SUCCESS = createSuccessType(
  CREATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const CREATE_METAL_STREAM_ALLOCATION_ERROR = createErrorType(
  CREATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const CREATE_METAL_STREAM_ALLOCATION_LOADING = createLoadingType(
  CREATE_METAL_STREAM_ALLOCATION_SCOPE,
);

// update metal stream allocation
const UPDATE_METAL_STREAM_ALLOCATION_SCOPE =
  'UPDATE_METAL_STREAM_ALLOCATION_SCOPE';
export const UPDATE_METAL_STREAM_ALLOCATION = createUpdateType(
  UPDATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const UPDATE_METAL_STREAM_ALLOCATION_SUCCESS = createSuccessType(
  UPDATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const UPDATE_METAL_STREAM_ALLOCATION_ERROR = createErrorType(
  UPDATE_METAL_STREAM_ALLOCATION_SCOPE,
);
export const UPDATE_METAL_STREAM_ALLOCATION_LOADING = createLoadingType(
  UPDATE_METAL_STREAM_ALLOCATION_SCOPE,
);

// create metal stream products
const CREATE_METAL_STREAM_PRODUCTS_SCOPE = 'CREATE_METAL_STREAM_PRODUCTS';
export const CREATE_METAL_STREAM_PRODUCTS = createSubmitType(
  CREATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const CREATE_METAL_STREAM_PRODUCTS_SUCCESS = createSuccessType(
  CREATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const CREATE_METAL_STREAM_PRODUCTS_ERROR = createErrorType(
  CREATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const CREATE_METAL_STREAM_PRODUCTS_LOADING = createLoadingType(
  CREATE_METAL_STREAM_PRODUCTS_SCOPE,
);

// update metal stream products
const UPDATE_METAL_STREAM_PRODUCTS_SCOPE = 'UPDATE_METAL_STREAM_PRODUCTS';
export const UPDATE_METAL_STREAM_PRODUCTS = createUpdateType(
  UPDATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const UPDATE_METAL_STREAM_PRODUCTS_SUCCESS = createSuccessType(
  UPDATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const UPDATE_METAL_STREAM_PRODUCTS_ERROR = createErrorType(
  UPDATE_METAL_STREAM_PRODUCTS_SCOPE,
);
export const UPDATE_METAL_STREAM_PRODUCTS_LOADING = createLoadingType(
  UPDATE_METAL_STREAM_PRODUCTS_SCOPE,
);

// get metal stream products
const GET_METAL_STREAM_PRODUCTS_SCOPE = 'GET_METAL_STREAM_PRODUCTS';
export const GET_METAL_STREAM_PRODUCTS = createFetchType(
  GET_METAL_STREAM_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_PRODUCTS_SUCCESS = createSuccessType(
  GET_METAL_STREAM_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_PRODUCTS_ERROR = createErrorType(
  GET_METAL_STREAM_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_PRODUCTS_LOADING = createLoadingType(
  GET_METAL_STREAM_PRODUCTS_SCOPE,
);

// get metal stream gold products
const GET_METAL_STREAM_GOLD_PRODUCTS_SCOPE = 'GET_METAL_STREAM_GOLD_PRODUCTS';
export const GET_METAL_STREAM_GOLD_PRODUCTS = createFetchType(
  GET_METAL_STREAM_GOLD_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_GOLD_PRODUCTS_SUCCESS = createSuccessType(
  GET_METAL_STREAM_GOLD_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_GOLD_PRODUCTS_ERROR = createErrorType(
  GET_METAL_STREAM_GOLD_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_GOLD_PRODUCTS_LOADING = createLoadingType(
  GET_METAL_STREAM_GOLD_PRODUCTS_SCOPE,
);

// get metal stream gold products
const GET_METAL_STREAM_SILVER_PRODUCTS_SCOPE =
  'GET_METAL_STREAM_SILVER_PRODUCTS';
export const GET_METAL_STREAM_SILVER_PRODUCTS = createFetchType(
  GET_METAL_STREAM_SILVER_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_SILVER_PRODUCTS_SUCCESS = createSuccessType(
  GET_METAL_STREAM_SILVER_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_SILVER_PRODUCTS_ERROR = createErrorType(
  GET_METAL_STREAM_SILVER_PRODUCTS_SCOPE,
);
export const GET_METAL_STREAM_SILVER_PRODUCTS_LOADING = createLoadingType(
  GET_METAL_STREAM_SILVER_PRODUCTS_SCOPE,
);

// create metal stream bank application funding
const CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE =
  'CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING';
export const CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING = createSubmitType(
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR = createErrorType(
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_LOADING = createLoadingType(
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);

// update metal stream bank application funding
const UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE =
  'UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING';
export const UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING = createUpdateType(
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR = createErrorType(
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_LOADING = createLoadingType(
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SCOPE,
);
